"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToast", {
    enumerable: true,
    get: function() {
        return useToast;
    }
});
var _react = _interop_require_default(require("react"));
var _react1 = require("@chakra-ui/react");
var _components = require("../..");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var useToast = function() {
    var toast = (0, _react1.useToast)();
    var toastDecorator = function(options) {
        var position = options.position, duration = options.duration, isClosable = options.isClosable, id = options.id, onCloseComplete = options.onCloseComplete, containerStyle = options.containerStyle, title = options.title, render = options.render, description = options.description, _options_titleAlignment = options.titleAlignment, titleAlignment = _options_titleAlignment === void 0 ? "left" : _options_titleAlignment, _options_status = options.status, status = _options_status === void 0 ? "success" : _options_status, _options_variant = options.variant, variant = _options_variant === void 0 ? "solid" : _options_variant;
        var isTitleLeftAligned = titleAlignment === "left";
        return toast(_object_spread({
            position: position,
            duration: duration,
            id: id,
            onCloseComplete: onCloseComplete,
            containerStyle: containerStyle,
            render: render ? render : function(param) {
                var onClose = param.onClose;
                return _react.default.createElement(_components.Alert, {
                    variant: variant,
                    status: status
                }, _react.default.createElement(_components.Alert.Icon, null), _react.default.createElement(_components.Flex, _object_spread({
                    direction: isTitleLeftAligned ? "row" : "column"
                }, isClosable && {
                    pr: "1.5rem"
                }), title && _react.default.createElement(_components.Alert.Title, _object_spread({}, isTitleLeftAligned && {
                    mr: "0.75rem"
                }), title), description && _react.default.createElement(_components.Alert.Description, null, description), isClosable && _react.default.createElement(_components.Alert.CloseButton, {
                    onClick: onClose,
                    color: variant === "solid" ? "text-light" : "text-primary"
                })));
            }
        }, options));
    };
    return Object.assign(toastDecorator, toast);
};
